import { useEffect } from "react";

const SUFFIX = " · RE//FORM PLACE CHI";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title.includes("RE//FORM") ? title : title + SUFFIX;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
}
